import { render } from "./CustomShiftsFilters.vue?vue&type=template&id=91220594&scoped=true&ts=true"
import script from "./CustomShiftsFilters.vue?vue&type=script&lang=ts"
export * from "./CustomShiftsFilters.vue?vue&type=script&lang=ts"

import "./CustomShiftsFilters.vue?vue&type=style&index=0&id=91220594&lang=scss&scoped=true"

import exportComponent from "/usr/src/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-91220594"]])

export default __exports__